import { formatMoscowInput } from "./moscowTime"
import { placementPath } from "./placementDraft"

export const occurrencePath = (id: string) =>
  `/telegram/post-bot/occurrences/${encodeURIComponent(id)}`
export const placementHistoryPath = (id: string) =>
  `${placementPath(id)}/history`

export function occurrenceTime(value: string | null): string | null {
  if (value === null) return null
  try {
    return `${formatMoscowInput(value, { legacyNaive: true }).replace("T", " ")} МСК`
  } catch {
    // Preserve an unrecognized recorded timestamp, rather than guess its timezone.
    return `${value} (исходное значение)`
  }
}
